(function () {
  'use strict';

  var root = document.querySelector('[data-llmb]');
  if (!root) return;

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-llmb-tab]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-llmb-panel]'));
  var names = panels.map(function (p) { return p.getAttribute('data-llmb-panel'); });

  function activate(name, push) {
    if (names.indexOf(name) === -1) name = 'books';
    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-llmb-panel') !== name;
    });
    tabs.forEach(function (tab) {
      tab.classList.toggle('is-active', tab.getAttribute('data-llmb-tab') === name);
    });
    if (push && window.history && window.history.replaceState) {
      // Preserve every other query param (e.g. ?page=N from pagination
      // links) — only 'tab' is ours to add, change or drop.
      var params = new URLSearchParams(window.location.search);
      if (name === 'books') {
        params.delete('tab');
      } else {
        params.set('tab', name);
      }
      var query = params.toString();
      var url = window.location.pathname + (query ? '?' + query : '');
      window.history.replaceState(null, '', url);
    }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function (event) {
      event.preventDefault();
      activate(tab.getAttribute('data-llmb-tab'), true);
    });
  });

  // Deep links from the account menu: /pages/my-books?tab=orders|profile
  // ('view' is reserved by Shopify — it switches the rendered template)
  var view = new URLSearchParams(window.location.search).get('tab');
  if (view) activate(view, false);
}());
